<template>
    <client-page>
        <v-container>
            <div class="tit-wrap text-center">
                <h2 class="tit tit--lg">언론보도</h2>
            </div>

            <router-view name="board" code="press" skin="gallery-outerlink" hide-write-button />
        </v-container>
	</client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        ClientPage,
    },
};
</script>
